import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useComparison } from "../../../features/comparison/lib/useComparison.js";
import { useFavorite } from "../../../features/favorite/lib/useFavorite.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const {
    redirects,
    isClickableComparison = true,
    isClickableFavorite = true,
    ...props
  } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const { t } = useTranslation(APP.name);
  const navigate = useAppNavigate();
  const [isCompared, toggleComparison] = useComparison(vehicleItem);
  const [isFavorite, toggleFavorites] = useFavorite(vehicleItem);
  const toggleFavoriteText = t(
    isFavorite ? "widgets.tileActions.favorites.remove" : "widgets.tileActions.favorites.add"
  );
  const toggleComparisonText = t(
    isCompared ? "widgets.tileActions.comparison.remove" : "widgets.tileActions.comparison.add"
  );
  const onComparisonClick = useCallback(() => {
    if (!isCompared || !isClickableComparison) {
      toggleComparison();
    }
  }, [isClickableComparison, isCompared, toggleComparison]);
  const onComparisonToggle = useCallback(() => {
    toggleComparison();
  }, [toggleComparison]);
  const onComparisonRedirect = useCallback(() => {
    navigate(redirects.onComparisonRedirect.to, redirects.onComparisonRedirect.options);
  }, [navigate, redirects.onComparisonRedirect.options, redirects.onComparisonRedirect.to]);
  const onFavoriteClick = useCallback(() => {
    if (!isFavorite || !isClickableFavorite) {
      toggleFavorites();
    }
  }, [isClickableFavorite, isFavorite, toggleFavorites]);
  const onFavoriteToggle = useCallback(() => {
    toggleFavorites();
  }, [toggleFavorites]);
  const onFavoriteRedirect = useCallback(() => {
    navigate(redirects.onFavoriteRedirect.to, redirects.onFavoriteRedirect.options);
  }, [navigate, redirects.onFavoriteRedirect.options, redirects.onFavoriteRedirect.to]);
  return {
    ...props,
    isFavorite,
    isClickableFavorite,
    toggleFavoriteText,
    onFavoriteClick,
    onFavoriteToggle,
    onFavoriteRedirect,
    isCompared,
    isClickableComparison,
    toggleComparisonText,
    onComparisonClick,
    onComparisonToggle,
    onComparisonRedirect,
    isLoading,
    t
  };
};
export {
  useContainer
};
